(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/active-vegas-suspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/active-vegas-suspension.js');
'use strict';

const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody;
const _svs$spelpaus$pages$s = svs.spelpaus.pages.svsSuspension.SvsSuspensionHelper,
  getProductText = _svs$spelpaus$pages$s.getProductText,
  getSuspensionTypeText = _svs$spelpaus$pages$s.getSuspensionTypeText,
  getActiveValideToDate = _svs$spelpaus$pages$s.getActiveValideToDate;
const ActiveVegasSuspension = _ref => {
  let suspension = _ref.suspension;
  return React.createElement(Card, {
    className: "margin-top-1"
  }, React.createElement(CardBody, null, React.createElement("h5", {
    className: "card-title"
  }, getProductText(suspension.product), ' ', getSuspensionTypeText(suspension.period, suspension.terminationPeriod)), React.createElement("p", {
    className: "card-text"
  }, "Spelpausen g\xE4ller", ' ', getProductText(suspension.product), ' till ', getActiveValideToDate(suspension), "."), suspension.terminable && React.createElement("p", {
    className: "card-text"
  }, "Kontakta Kundservice efter spelpaus f\xF6r att aktivera", ' ', getProductText(suspension.product), ' ', "efter", ' ', getSuspensionTypeText(suspension.period, suspension.terminationPeriod), "."), !suspension.terminable && React.createElement("p", {
    className: "card-text"
  }, "Spelpausen upph\xF6r automatiskt efter", ' ', getSuspensionTypeText(suspension.period, suspension.terminationPeriod), ".")));
};
svs.spelpaus.pages.svsSuspension.components.ActiveVegasSuspension = ActiveVegasSuspension;

 })(window);